export type AdminTopBarType =
  | "Userlist"
  | "Recon Mapping"
  | "Sap Data"
  | "Ledger Data"
  | "Disbursment Account"
  | "Collection Account"
  | "Config Templates"
  | "Tally Voucher"
  | "Tally Ledger"
  | "CB Update"
  | "Unpaid Invoice"
  | "Payment Details"
  | "Register"
  | "Preprocessing Scripts";

export const AdminTopBar = {
  Userlist: "Userlist",
  ReconMapping: "Recon Mapping",
  SapData: "Sap Data",
  LedgerData: "Ledger Data",
  DisbursmentAccount: "Disbursment Account",
  CollectionAccount: "Collection Account",
  ConfigTemplates: "Config Templates",
  TallyVoucher: "Tally Voucher",
  TallyLedger: "Tally Ledger",
  CBUpdate: "CB Update",
  UnpaidInvoice: "Unpaid Invoice",
  PaymentDetails: "Payment Details",
  Register: "Register",
};

export interface SubMenu {
  name: string;
  to: string;
  className?: string;
  icon?: JSX.Element;
  eventName?: string;
  show?: boolean;
}

export interface NavBarStructure {
  hasSubTab: boolean;
  name: string;
  to?: string;
  className?: string;
  subMenu?: SubMenu[];
  show?: boolean;
  icon?: JSX.Element;
  eventName?: string;
}
